// Import necessary functions and modules
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiSliceInterceptor } from "stores/redux/apiSliceInterceptor";


const Product = createApi({
    reducerPath: "Product",
    baseQuery: apiSliceInterceptor.baseQueryWithInterceptor,
    tagTypes: ["GEPRODUCTLIST", "ADDPRODUCT", "UPDATEPRODUCT"],
  
    endpoints: (qb) => ({
      getProductsListApi: qb.query({
        query: (filters) => {
          const {
            search,
            status,
            favourite,
            minPrice,
            maxPrice,
            measurementType,
            page = 1,
            limit = 1000,
            noGlobalLoading = true,
            isActive,
            isFavourite, // <-- Add this
          } = filters || {};
      
          // Construct params object dynamically, only including defined values
          const params = { page, limit, noGlobalLoading };
          if (search) params.search = search;
          if (status) params.status = status;
          if (favourite) params.favourite = favourite;
          if (minPrice) params.minPrice = minPrice;
          if (maxPrice) params.maxPrice = maxPrice;
          if (measurementType) params.measurementType = measurementType;
          if (isActive !== undefined) params.isActive = isActive;
          if (isFavourite !== undefined) params.isFavourite = isFavourite;
      
          // Log the API request to debug
          console.log("Fetching products with params:", params);
      
          return {
            url: `api/product`,
            params,
          };
        },
        transformResponse: (response) => {
          console.log("API Response:", response);
          return response;
        },
        providesTags: ["GEPRODUCTLIST"],
      }),
      
        getProductsMasterListApi: qb.query({
          query: () => ({
            url: `api/product/master`,
            params: {
              page: 1,
              limit: 10,
              noGlobalLoading: true,
            },
          }),
          transformResponse: (response) => {
            console.log("API Response:", response);
            return response;
          },
          providesTags: ["GEPRODUCTLIST"],
        }),
        
        
        
  
      addProductApi: qb.mutation({
        query: (data) => ({
          url: `api/product`,
          method: "POST",
          body: data,
        }),
        invalidatesTags: ["ADDPRODUCT"],
      }),
  
      updateProductApi: qb.mutation({
        query: (data) => ({
          url: `api/product`,
          method: "PUT",
          body: data, 
        }),
        invalidatesTags: ["UPDATEPRODUCT"],
      }),
      
      
    }),
  });
  
  export const ProductsApiReducer = Product.reducer;
  
  export const productsApiAction = {
    middleware: Product.middleware,
    reducerPath: Product.reducerPath,
    getProductsListApi: Product.useGetProductsListApiQuery,
    getProductsMasterListApi:Product.useGetProductsMasterListApiQuery,
    addProductApi: Product.useAddProductApiMutation,
    updateProductApi: Product.useUpdateProductApiMutation,
  };
  
